import styled from '@emotion/styled';
import { Box, Button, Paper, Popper } from '@material-ui/core';

export const CustomFilterForm = styled.form`
  width: 100%;
`;

export const CustomPopper = styled(Popper)`
  z-index: 5;
`;

export const FilterButton = styled(Button)<{ opened: number; filtered: number }>`
  background-color: ${({ opened, filtered }) => (filtered ? '#ccedfa' : opened ? '#d7dbdd' : 'transparent')} !important;
  color: ${({ filtered }) => (filtered ? '#00a4e4' : '#555')};

  .MuiButton-startIcon {
    margin-right: 2px;
  }
`;

export const FilterFormButton = styled(Button)`
  width: 30%;

  &:first-of-type {
    margin-right: 15px;
  }
`;

export const FilterFormButtonContainer = styled(Box)`
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
`;

export const PopperArrow = styled.span`
  position: absolute;
  width: 1em;
  height: 1em;
  box-sizing: border-box;
  left: 30px;
  top: -5px;

  &::before {
    width: 100%;
    height: 100%;
    margin: auto;
    content: '';
    display: block;
    transform: rotate(45deg);
    box-shadow: -5px -5px 8px -6px rgb(0 0 0 / 75%);
    background-color: #fff;
  }
`;

export const CustomPaper = styled(Paper)`
  border-radius: 10px !important;
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 420px;
  max-width: 40vw;
`;
